<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-04-17 10:56:50
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-05-21 16:57:48
 * @FilePath: /goldenSalesMobile/src/views/GoodsPoster/index.vue
 * @Description: 
-->
<template>
  <div class='page-container'>
    <!-- <nav-bar title="分销海报" /> -->
    <p class="tip-text">他人购买并核销后，您将获得{{ commission }}元推广奖励</p>
    <div class="post-box">
      <img :src="posterImg" >
    </div>
    <div class="btn-list">
      <div @click="onCopyLink">
        <img src="../../assets/poster_image/link_icon.png" alt="">
        <span>复制链接</span>
      </div>
      <!-- <div @click="downloadCodeImg">
        <img src="../../assets/poster_image/vcode_icon.png" alt="">
        <span>保存二维码</span>
      </div> -->
      <div @click="onSavePoster">
        <img src="../../assets/poster_image/save_icon.png" alt="">
        <span>保存海报</span>
      </div>
      <div @click="onSharePoster">
        <img src="../../assets/poster_image/share_icon.png" alt="">
        <span>分享海报</span>
      </div>
    </div>
  </div>
</template>

<script>
import { handleClipboard } from '@/utils/clipboard'
import { getProductPoster } from '@/api/goods'

export default {
  data() {
    return {
      productId: this.$route.params.id,
      commission: this.$route.params.cs,
      posterImg: '',
      vcodeImg: '',
      linkUrl: ''
    }
  },

  created() {
    getProductPoster(this.productId)
      .then(res => {
        this.posterImg = this.getImg(res.PosterBase64)
        this.vcodeImg = this.getImg(res.QrCodeBase64)
        this.linkUrl = res.Url
      })
  },

  methods: {
    getImg(response) {
      return 'data:image/png;base64,' + response
    },
    onCopyLink() {
      handleClipboard(this.linkUrl, event, () => { this.$toast('购买链接已复制，快去粘贴吧~') }, () => { this.$toast('复制失败') })
    },
    // 此方法在不同浏览器表现不一致，ios和微信浏览器以及安卓手机点击下载都是直接跳转图片链接，原生谷歌手机可以下载
    // downloadCodeImg() {
    //   console.log('下载图片')
    //   var a = document.createElement('a')
    //   a.download = name || 'img'
    //   // 设置图片地址
    //   a.href = 'https://www.vitian.vip/Public/img/home/banner2.jpg';
    //   a.click();
    // }
    // 此方法只支持PC端下载，移动端不支持点击下载，改用系统自带长按图片保存到相册
    // downloadIamge(src, name) {//下载图片地址和图片名
    //   var image = new Image();
    //   // 解决跨域 Canvas 污染问题
    //   image.setAttribute("crossOrigin", "anonymous");
    //   image.onload = function() {
    //     var canvas = document.createElement("canvas");
    //     canvas.width = image.width;
    //     canvas.height = image.height;
    //     var context = canvas.getContext("2d");
    //     context.drawImage(image, 0, 0, image.width, image.height);
    //     var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
    //     var a = document.createElement("a"); // 生成一个a元素
    //     var event = new MouseEvent("click"); // 创建一个单击事件
    //     a.download = name || "photo"; // 设置图片名称
    //     a.href = url; // 将生成的URL设置为a.href属性
    //     a.dispatchEvent(event); // 触发a的单击事件
    //   };
    //   image.src = src;
    // },
    // downloadCodeImg(){
    //   this.downloadIamge(this.vcodeImg, 'pic')
    // },
    onSavePoster() {
      this.$toast('请长按海报保存到相册')
    },
    onSharePoster() {
      this.$toast('请长按海报转发好友')
    }
  }
}
</script>

<style lang='scss' scoped>
  .page-container {
    background: $blockBgColor;

    .post-box {
      margin: 0 auto 50px;
      width: 630px;
      height: 928px;
      background: $blockBgColor;
      box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.09);
      border-radius: 20px;

      >img {
        width: 100%;
        height: 100%;
      }
    }

    .tip-text {
      margin-bottom: 20px;
      text-align: center;
      line-height: 60px;
      font-size: 30px;
      font-weight: 400;
      color: #FF9F00;
      background:rgba(255,159,0,.1);
    }

    .btn-list {
      @include flex-box(space-between);
      @include border-box(0 70px);
      width: 100%;
      
      >div {
        @include flex-box(center);
        flex-direction: column;

        >img {
          width: 84px;
          height: 84px;
          margin-bottom: 10px;
        }

        >span {
          font-size: 26px;
          font-weight: 400;
          color: $secondFontColor;
          line-height: 36px;
        }
      }
    }
  }
</style>

